import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/svg/logoIcon";
import { useAuth } from "../../context/authContext";
import createAxiosInstance from "../../utils/axiosConfig";
import { login_user } from "../../utils/endpoints";
import { validate } from "../../utils/formValidate";
import Alert from "../common/alerts/alert";

const Login: React.FC = () => {
	const { login, isAuthenticated } = useAuth();
	const navigate = useNavigate();

	const [formData, setFormData] = useState({
		password: "",
		email: "",
	});

	const [errors, setErrors] = useState<any>({});
	const [, setResponse] = useState<any>({});
	const [responseError, setResponseError] = useState<any>({});
	const [alertVisible, setAlertVisible] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (
		e: React.ChangeEvent<
			HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
		>
	) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
		validate({ [name]: value }, setErrors);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!validate(formData, setErrors)) return;
		setLoading(true);
		const payload = {
			password: formData.password,
			email: formData.email,
		};

		try {
			const axiosInstance = createAxiosInstance();
			const response = await axiosInstance.post(login_user, payload);
			setResponse(response.data);

			if (response.data?.access_token && response.data?.access_token !== "") {
				login(response.data?.id, response.data?.access_token, response.data);
				navigate("/chat");
			} else {
				
				if(response.data?.mfa_required && response.data?.message !== "") {
					console.log("response.data", response.data);
					setResponseError({
						response: {
							data: {
								detail: response.data?.message
							}
						}
					});
					console.log("responseError hehe", responseError);
				} else {
					setResponseError(response.data);
				}
			}
			setFormData({
				password: "",
				email: "",
			});
		} catch (err) {
			console.log("i am running12333!");
			setResponseError(err);
			console.log(err);
		}finally{
			setLoading(false);
		}
	};

	useEffect(() => {
		console.log("responseError", responseError);
		if (responseError?.response?.data?.detail.length > 1) {
			setAlertVisible(true);
		}
		if (isAuthenticated) {
			console.log("isAuthenticated", isAuthenticated);
			navigate("/chat");
		}
	}, [responseError]);

	return (
		<section className="authentication min-vh-100">
			<header className="p-4">
				<div className="container-fluid">
					<div className="card d-flex align-items-center logo-container">
						<LogoIcon />
					</div>
				</div>
			</header>
			
			<div className="container-fluid">
				<div className="row align-items-center min-vh-75 w-100">
					<div className="col-md-12 col-lg-12 col-xl-12">
						<div className="login-container">
							<div className="mb-3">
								{/* <LogoIcon /> */}
							</div>
							<h2 className="my-3 my-md-4" style={{color: "white", fontSize: "26px", fontWeight: '700', lineHeight: '40px', fontFamily: 'Roboto'}}>LOGIN</h2>

							<form onSubmit={handleSubmit}>
								<div className="mb-4">
									<label htmlFor="email" className="form-label text-white mb-2">Email address</label>
									<input
									type="email"
									className={`form-control form-control-lg bg-white rounded-4 ${errors.email ? "is-invalid" : ""}`}
									id="email"
									name="email"
									value={formData.email}
									onChange={handleChange}
									// placeholder="Email address"
									/>
									{errors.email && <div className="invalid-feedback">{errors.email}</div>}
								</div>
								
								<div className="mb-3">
									<div className="position-relative d-flex justify-content-between">
									<label htmlFor="password" className="form-label text-white mb-2">Password</label>
									<div>
										<span 
											// type="button" 
											className="btn btn-link"
											onClick={() => setShowPassword(!showPassword)}
											style={{ textDecoration: "none", color: 'white' }}
										>
											<i className={`bi ${showPassword ? "bi-eye-fill" : "bi-eye-slash-fill"}`} style={{color: 'white', paddingTop: '50px', paddingRight: '10px'	}}></i>
											{showPassword ? "Hide" : "Show"}
										</span>
									</div>
									</div>
									{/* <div className="position-relative"> */}
									<input
										type={showPassword ? "text" : "password"}
										className={`form-control form-control-lg bg-white rounded-4 ${errors.password ? "is-invalid" : ""}`}
										id="password"
										name="password"
										value={formData.password}
										onChange={handleChange}
										// placeholder="Password"
									/>
									
									{errors.password && <div className="invalid-feedback">{errors.password}</div>}
									{/* </div> */}
								</div>
								
								<div className="mb-4">
									<p className="text-white d-block mb-4" style={{cursor: 'pointer'}} onClick={() => navigate("/forgotPassword")}>
										Forgot your Password? <u>CLICK HERE</u>
									</p>
								</div>
								
								<div className="mb-4" style={{
									marginTop: '10%'
								}}>
								</div>
								<div className="d-flex flex-row flex-grow-1 gap-3 align-items-center">
									<div className="d-grid login-btn-container gap-2">
										<button 
											type="submit" 
											className="w-100 btn btn-rounded btn-secondary text-white fw-bold py-3"
											disabled={Object.keys(errors).length > 0}
											style={{
												// borderRadius: '10px',
												background: '#26397E',
												borderRadius: "77.125rem",
												transition: 'all 0.3s ease',
											}}
											onMouseEnter={(e) => {
												const target = e.target as HTMLButtonElement;
												target.style.backgroundColor = '#5376F0 !important';
												target.style.transform = 'translateY(-2px)';
											}}
											onMouseLeave={(e) => {
												const target = e.target as HTMLButtonElement;
												target.style.backgroundColor = '#26397E';
												target.style.transform = 'translateY(0)';
											}}
										>
											{loading ? <div
												className="d-flex justify-content-center align-items-center"
												style={{ height: "20px", color: 'white' }}
											>
												<div className="spinner-border text-white" role="status">
													<span className="visually-hidden">Loading...</span>
												</div>
											</div> : "SIGN IN"}
										</button>
									</div>
										
									{/* <div className="mt-3 text-white text-center">
										Don't have an account? <a href="/signup" className="text-white fw-bold"><u>SIGN UP</u></a>
									</div> */}
								</div>
									
							</form>
							
						</div>	
					</div>
					{/* <div className="col-md-12 col-lg-6 col-xl-6">
						<img src={require("../../assets/img/bg-public.png")} alt="bg-public" />
					</div> */}
					{/* <Footer /> */}
				</div>
				<div className="row">
					<div className="d-flex justify-content-end" style={{
						marginRight: '10%',
						paddingRight: '3%',
						marginTop: '1%'
					}}>
						<div className="text-white my-2 px-3">
							Powered By: 
						</div>
						<div className="card d-flex align-items-center logo-container">
								<LogoIcon />
						</div>
					</div>
				</div>
				</div>
			<div className="text-black d-flex flex-row flex-wrap gap-2 footer-container">
				Some information about the platform:
				<ul style={{
					listStyleType: 'none',
					paddingLeft: '0',
					marginLeft: '0',
					display: 'flex',
					flexDirection: 'row',
					gap: '10'
				}}>
					<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate("/terms-and-conditions")}> Terms & conditions </li>
					<li style={{borderRight: '1px solid black', paddingRight: '10px', textDecoration: 'underline', paddingLeft: '10px', cursor: 'pointer'}} onClick={() => navigate("/privacy-policy")}>Privacy Policy</li>
					<li style={{cursor: 'pointer', paddingLeft: '10px', textDecoration: 'underline'}} onClick={() => navigate("/disclaimer")}>Disclaimer</li>
				</ul>
			</div>
			<Alert
				message={`${
					responseError?.response?.data?.detail.length > 1
						? responseError.response?.data?.detail
						: "Login successfull."
				}`}
				type={`${
					responseError?.response?.data?.detail.length > 1
						? "danger"
						: "success"
				}`}
				show={alertVisible}
				onClose={() => setAlertVisible(false)}
			/>
		</section>
	);
};

export default Login;
